import { Avatar, Collapse, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import type { Dashboard } from "../../../../../api/types/dashboardsTypes.ts";
import DashboardIcon from "@entrilia/shared/icons/DashboardIcon.tsx";
import { ExpandCollapseButton } from "../../../reporting/report-lists/reports/components/ExpandCollapseButton.tsx";

interface Props {
  dashboard: Dashboard;
  widgets: number;
  children: React.ReactNode;
  Action?: React.ReactElement;
  Summary?: React.ReactElement;
}

const CompanyDashboardListItem = ({ dashboard, widgets, children, Action, Summary }: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Paper variant="outlined" sx={(theme) => ({ borderColor: theme.palette.divider, width: "100%" })}>
      <Stack>
        <Stack direction="row" sx={{ pr: 1, alignItems: "center" }}>
          <Grid
            container
            sx={{ pr: 1, pl: 2, pt: 1.5, spacing: 1.5, alignItems: "center", direction: "row", width: "100%" }}
          >
            <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flexGrow: 1 }}>
              <Avatar sx={{ width: 24, height: 24, borderRadius: 1 }}>
                <DashboardIcon />
              </Avatar>
              <Typography variant="subtitle1">{dashboard.nameUserInput}</Typography>
            </Stack>
            {Action}
          </Grid>
        </Stack>
        <Grid container sx={{ width: "100%" }}>
          <Stack sx={{ flex: 1, width: "100%" }}>
            <Stack direction="row" sx={{ alignItems: "center", flexGrow: 1, pl: 1.5, pr: 2, pb: 0.5 }}>
              <ExpandCollapseButton expanded={expanded} onClick={setExpanded} />
              <Typography sx={{ color: "text.primary" }}>{widgets} Widgets</Typography>
              <HorizontalFill />
              {Summary}
            </Stack>
            <Collapse in={expanded}>
              <Divider />
              <Stack
                spacing={1}
                useFlexGap
                sx={{
                  p: 1.5,
                  bgcolor: "background.grey",
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                  width: "100%",
                }}
              >
                {children}
              </Stack>
            </Collapse>
          </Stack>
        </Grid>
      </Stack>
    </Paper>
  );
};

export default CompanyDashboardListItem;
